import { isIpfError } from '@ipfabric/frontend-shared-assets/utils/IpfError';
import { API_LICENSE_NOT_FOUND } from '@ipfabric/utils';
import type {
  GlobalStateCommandFactory,
  LicenseValidityApiResponse,
} from 'components/GlobalState/GlobalStateModel';
import { handleInitialAppRequest } from 'components/GlobalState/commands/handleInitialAppRequest';

export const verifyLicense: GlobalStateCommandFactory =
  (cmdContext, dispatch) => async () => {
    try {
      await dispatch(handleInitialAppRequest, async () => {
        const license =
          await cmdContext.api.request<LicenseValidityApiResponse>({
            url: '/licenses/validity',
            method: 'GET',
          });
        cmdContext.updateState((draft) => {
          draft.license.validTo = license.validTo ?? null;
          draft.license.state = !license.expired ? 'VALID' : 'EXPIRED';
          draft.license.additionalFeatures = license.additionalFeatures;
        });
      });
    } catch (e) {
      const isLicenseNotFoundError =
        isIpfError(e, 'API') &&
        e.payload?.response.code === API_LICENSE_NOT_FOUND;
      cmdContext.updateState((draft) => {
        draft.license.state = isLicenseNotFoundError ? 'NOT_FOUND' : 'ERROR';
      });
      if (!isLicenseNotFoundError) {
        throw e;
      }
    }
  };
